<template>
  <div class="col-12">
    <div v-if="cards.length" class="row card-selection-field">
      <div
        v-for="card in cards"
        :key="card.id"
        class="user-card-field selectable-field green-selectable-field"
        @click="selectCard(card)"
        :class="{ selected: selectedCard.id === card.id }"
      >
        <div class="user-card-field-inner">
          <div class="user-card-left-field">
            <div class="image-field">
              <img :src="card.brand ? '/img/' + card.brand + '.svg' : '/img/default-card.svg'" alt="mastercard" />
            </div>

            <div>
              <div class="user-card-header-item">Kredi Kartı</div>
              <div class="user-card-number-item">{{ card.masked_number }}</div>
              <div class="user-card-info-item">{{ card.holder_name }}</div>
            </div>
          </div>
          <div>
            <div class="circle-field relative rounded-full ml-4">
              <div class="inner-circle-field" />
            </div>
          </div>
        </div>
      </div>

      <div class="other-field w-100">
        <div
          class="user-card-field selectable-field green-selectable-field"
          @click="selectCard({ id: 'other' })"
          :class="{ selected: selectedCard.id === 'other' }"
        >
          <div class="user-card-field-inner">
            <div class="user-card-left-field">
              <div class="image-field">
                <img src="/img/default-card.svg" alt="mastercard" />
              </div>

              <div>
                <div class="user-card-number-item">Başka Kartla Öde</div>
              </div>
            </div>
            <div>
              <div class="circle-field relative rounded-full ml-4">
                <div class="inner-circle-field" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedCard: {
      type: Object,
      default: {},
    },
    isHaveCards: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cards: [],
    };
  },
  created() {
    $axios
      .get('tenant/cards')
      .then((s) => {
        this.cards = s.data.data;
        if (this.cards.length) {
          this.$emit('update:isHaveCards', true);
        } else {
          this.$emit('update:isHaveCards', false);
        }
      })
      .catch((s) => {
        this.cards = [];

        this.$emit('update:isHaveCards', false);
      });
  },
  methods: {
    selectCard(card) {
      this.$emit('update:selectedCard', card);
    },
  },
};
</script>

<style lang="less" scoped>
.card-selection-field {
  margin-bottom: 16px;
  display: flex;
  gap: 15px;
}

.user-card-field {
  flex: 1 1 calc(50% - 20px);
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 16px;
  border: 2px solid #dedede;
  border-radius: 4px;
  @media (max-width: 512px) {
    flex: 100%;
  }
  &.selected {
    border-color: #36cf94;
    border-style: solid;
  }

  .user-card-field-inner {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-between;
    width: 100%;
  }

  .user-card-left-field {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .image-field {
    border-radius: 9999px;
    filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.05));
    padding: 12px;
    border: 1px solid #ececec;
    width: 43px;
    height: 43px;
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
    }
  }

  .user-card-header-item {
    font-size: 12px;
    line-height: 20px;
    opacity: 0.5;
    margin-bottom: 4px;
  }
  .user-card-number-item {
    font-size: 14px;
    line-height: normal;
    margin-bottom: 4px;
    font-weight: 500;
  }
  .user-card-info-item {
    font-size: 12px;
    font-style: normal;
    line-height: normal;
  }
}
</style>
